import { useTranslation } from 'react-i18next';
import { ThemeName } from 'states/UiState';
import { useThemePreference } from 'states/useThemePreference';
import { IconDropdown } from './IconDropdown';

// Built from `t` inside the component rather than as a module-level
// constant, which would freeze the labels in whatever language was active
// at load time.
const getThemes = (t: (key: string) => string): { name: ThemeName; label: string; icon: string }[] => [
  { name: 'light', label: t('THEME.LIGHT'), icon: 'wb_sunny' },
  { name: 'dark', label: t('THEME.DARK'), icon: 'brightness_2' },
];

export const ThemeSelector = () => {
  const { t } = useTranslation();
  const [activeTheme, setActiveTheme] = useThemePreference();
  const themes = getThemes(t);
  const currentTheme = themes.find((theme) => theme.name === activeTheme) || themes[0];

  return (
    <IconDropdown
      triggerIcon={currentTheme.icon}
      triggerTitle={t('THEME.CHANGE_THEME')}
      options={themes.map((theme) => ({ key: theme.name, label: theme.label, icon: theme.icon }))}
      activeKey={activeTheme}
      onSelect={(key) => setActiveTheme(key as ThemeName)}
    />
  );
};
